<div class="field-box" [class.has-options]="HasOptions" [class.has-title]="showTitle" [class.open]="IsOpen">
    <upp-kb-input #input
        [ngClass]="{ 'title': value !== null }"
        [ngStyle]="{ 'margin-bottom': '0px' }"
        type="text"
        [kiosk]="kiosk"
        [name]="formControlName"
        [placeholder]="placeholder"
        [value]="value"
        [readonly]="readonly"
        [disabled]="IsDisabled"
        (Focused)="OnFocus()"
        (Changed)="OnTextChanged($event)"
        autocomplete="off"
    ></upp-kb-input>
    <button *ngIf="HasOptions" uppDataid="input-select-expand"
        type="button"
        class="expand"
        [disabled]="IsDisabled"
        (click)="OnToggle($event)"
    >
        <ion-icon [name]="IsOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
    </button>
</div>
<ion-label class="input-title" [ngClass]="{ 'hide': !showTitle }">{{ title }}</ion-label>
<upp-er-input *ngIf="formGroup"
    [form]="formGroup"
    [name]="formControlName"
    [value]="value"
    [errornfo]="errornfo"
></upp-er-input>
<div class="anchor" [class.open]="IsOpen">
    <div class="dropdown-collapse" [class.open]="IsOpen">
        <div class="dropdown" role="listbox" tabindex="0" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <div class="inner">
                <upp-scrollable [scrollbar]="'y'">
                    <ion-list class="upp-input-select-list">
                        <ion-item *ngFor="let option of Options" [uppDataid]="'input-select-option-' + option"
                            lines="none"
                            button
                            detail="false"                            
                            (click)="OnPick(option)"
                        >
                            <ion-label>{{ option }}</ion-label>
                        </ion-item>
                    </ion-list>
                </upp-scrollable>
            </div>
        </div>
    </div>
</div>
